<form class="form-container  campaign-filter-container " [formGroup]="filterFormGroup" (ngSubmit)="search.emit(filterFormGroup.value)">
  <div class="form-row">
    <div class="col-2 align-right">
      <label for="firstName" class="col-form-label-sm text-label">{{ "common.first_name" | translate }}</label>
    </div>
    <div class="col-4">
      <input type="text" formControlName="firstName" class="form-control" id="firstName" placeholder="" value="">
    </div>
    <div class="col-2 align-right">
      <label for="lastname" class="col-form-label-sm text-label">{{ "common.last_name" | translate }}</label>
    </div>
    <div class="col-4">
      <input type="text"  formControlName="lastName" class="form-control" id="lastname" placeholder="" value="">
    </div>
  </div>
  <div class="form-row">
    <!-- <div class="col-2 align-right">
      <label for="email" class="col-form-label-sm text-label">{{ "common.employee_email_address" | translate }}</label>
    </div>
    <div class="col-4">
      <input type="text" formControlName="email" class="form-control" id="email" placeholder="" value="">
    </div> -->
    <div class="col-2 align-right">
      <label for="employeeId" class="col-form-label-sm text-label">{{ "common.employee_number" | translate }}</label>
    </div>
    <div class="col-4">
      <input type="text"  formControlName="employeeId" class="form-control" id="employeeId" placeholder="" value="">
    </div>
  </div>
  <div class="align-right">
    <button  (click)="onClearFilter()" class="uw-stroked-button uw-button--medium">
      {{ "common.clear" | translate }}
    </button>
    <button type="submit" class="uw-secondary-button uw-button--medium">
      {{ "common.search" | translate }}
    </button>
  </div>
</form>
